import { ILocationState } from '../../../types'

const initialState: ILocationState = {
  isFetching: false,
  items: {
    1: {
      locationId: 1,
      pickUpCoord: {
        lat: 27,
        lng: 120
      },
      pickUpFullAddress: '707 NE Fremont St, Portland',
      dropOffCoord: {
        lat: 27,
        lng: 120
      },
      dropOffFullAddress: '1123 N Hayden Meadows Dr, Portland',
      placeName: 'Place 1',
      name: 'Place 1'
    },
    2: {
      locationId: 1,
      pickUpCoord: {
        lat: 27,
        lng: 120
      },
      pickUpFullAddress: '707 NE Fremont St, Portland',
      dropOffCoord: {
        lat: 27,
        lng: 120
      },
      dropOffFullAddress: '1123 N Hayden Meadows Dr, Portland',
      placeName: 'Place 2',
      name: 'Place 2'
    }
  },
  lastUpdated: 0
}

export function locations(state: ILocationState, action: any): any {
  if (typeof state === 'undefined') {
    return initialState
  }
  return state
}



// WEBPACK FOOTER //
// ./src/state/reducers/locations/index.ts